
import LayoutMixin from '@/mixins/layout'
import SupportTop from '@/components/page/support-top.vue'

export default {
  components: {
    SupportTop,
  },
  mixins: [LayoutMixin],
  async asyncData({ app, route }) {
    let result = {}
    const {
      params: { site },
    } = route
    try {
      const res = await app.$API.support.getSupportContent({ type: 13 }) // 13-公司介绍/关于我们
      if (res && res.length > 0) {
        result = res[0] || {}
      }
    } catch (e) {
      result = {}
    }
    return {
      site,
      result,
    }
  },
  data() {
    return {
      name: '',
      content: '',
    }
  },
  head() {
    return {
      title: this.$t(`modules.intro.menu.introduce`),
    }
  },
  computed: {
    service() {
      return this.result
    },
  },
}
